<div class="site-text">
    <p class="text">
        La liste suivante a été conçue pour vous aider à trouver au plus vite une réponse à votre question ou l’interlocuteur qui convient.
    </p>
    <p class="title">
        Mon organisation n’apparaît pas dans le répertoire.
    </p>
    <p class="text">
        eDirectory.ch recense les entreprises et organisations domiciliées en Suisse qui échangent des e-factures avec leurs partenaires commerciaux par le biais d’un prestataire de services d’e-facturation rattaché à eDirectory et qui ont donné à celui-ci le droit de publication dans eDirectory. Si vous avez des questions à ce sujet, n’hésitez pas à vous tourner vers votre prestataire de services d’e-facturation.
    </p>
    <p class="text">
        Les émetteurs de factures qui envoient des factures électroniques aux destinataires eBill peuvent être trouvés grâce aux fonctions eBill correspondantes dans les applications e-banking des banques suisses. Si vous avez des questions à ce sujet, n’hésitez pas à vous tourner vers votre partenaire réseau eBill.
        <br>
        Plus d’informations sur <a href="https://www.ebill.ch" target="_blank">www.ebill.ch</a>
    </p>
    <p div class="title">
        Les données relatives à mon organisation ne sont pas correctes.
    </p>
    <p class="text">
        Informez votre prestataire de services d’e-facturation afin qu’il puisse adapter ses données.
    </p>
    <p class="title">
        En tant que prestataire de services d’e-facturation, je souhaite recenser mes clients également sur eDirectory.ch.
    </p>
    <p class="text">
        Si, en tant que prestataire de services d’e-facturation, vous proposez à des entreprises et organisations domiciliées en Suisse des prestations d’e-facturation et que vous souhaitez publier vos clients sur eDirectory, merci de faire part de votre intérêt à PostFinance <a href="mailto:billing-solutions@postfinance.ch?subject=eDirectory">(billing-solutions@postfinance.ch)</a>. Nous vous contacterons le plus rapidement possible.
    </p>
</div>
